import { Link } from "react-router-dom";
import VideoCard from "@/components/base/VideoCard";
import { useFavorites } from "@/hooks/useFavorites";
import { usePageMeta } from "@/hooks/usePageMeta";
import { videos } from "@/mocks/videos";

export default function Favorites() {
  const { ids } = useFavorites();
  const list = ids
    .map((id) => videos.find((item) => item.id === id))
    .filter((item): item is (typeof videos)[number] => Boolean(item));

  usePageMeta(
    "我的收藏 - 芒果视频",
    "这里是你在芒果视频收藏的影视内容，收藏保存在浏览器本地，随时可以回来继续查看。",
    "我的收藏,芒果视频收藏,影视收藏,想看清单"
  );

  return (
    <div className="mx-auto w-full max-w-[1440px] px-4 py-6 md:px-6 md:py-8 lg:px-10">
      <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">我的收藏</h1>
      <p className="mt-2 text-sm text-foreground-600">
        收藏保存在浏览器本地（演示），换设备或清理数据后不会同步。
      </p>

      {list.length > 0 ? (
        <>
          <p className="mt-5 text-sm text-foreground-600">
            共收藏 <span className="font-semibold text-primary-400">{list.length}</span> 部内容
          </p>
          <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-5">
            {list.map((item) => (
              <VideoCard key={item.id} item={item} />
            ))}
          </div>
        </>
      ) : (
        <div className="mt-8 flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-500">
            <i className="ri-heart-3-line text-3xl"></i>
          </span>
          <h2 className="mt-4 font-heading text-lg font-semibold text-foreground-900">还没有收藏任何内容</h2>
          <p className="mt-2 max-w-md text-sm text-foreground-600">
            在影视详情页点击「加入收藏」，就能把想看的内容收进这里，方便下次快速找到。
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link
              to="/category"
              className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              去发现内容
            </Link>
            <Link
              to="/"
              className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-500 hover:text-primary-400"
            >
              返回首页
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}